import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1058.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1058.000000) scale(0.100000,-0.100000)">

<path d="M3542 7683 l3 -78 100 -6 c55 -4 144 -10 198 -14 l97 -7 0 -239 c0
-132 3 -239 8 -239 4 1 26 32 50 70 92 148 255 294 428 382 187 96 309 123
539 122 150 -1 182 -4 268 -27 436 -116 750 -443 847 -883 25 -113 27 -338 5
-446 -22 -104 -70 -242 -110 -317 -19 -36 -33 -67 -30 -69 6 -6 147 72 230
128 237 160 372 379 391 639 11 154 -20 329 -82 460 -155 330 -456 495 -1054
578 -96 13 -263 16 -1003 20 l-888 5 3 -79z"/>
<path d="M4815 7499 c-144 -21 -319 -98 -453 -199 -260 -196 -411 -543 -412
-942 0 -133 14 -239 47 -343 89 -281 309 -530 663 -750 84 -52 498 -265 516
-265 23 0 486 -239 564 -291 166 -111 261 -226 297 -359 24 -90 24 -271 -1
-365 -41 -157 -149 -304 -280 -384 -71 -42 -201 -88 -291 -101 -39 -5 -215
-10 -392 -10 l-323 0 0 758 0 758 -86 48 c-279 155 -541 376 -666 561 -24 35
-46 65 -50 65 -5 0 -8 -499 -8 -1110 l0 -1110 -59 0 c-32 0 -79 -3 -105 -6
l-46 -7 0 -78 0 -79 870 0 c963 0 981 1 1212 64 275 76 477 192 649 373 162
170 263 371 304 608 22 119 19 342 -4 459 -48 235 -158 451 -321 629 -132 142
-181 172 -818 491 -617 310 -754 389 -859 495 -136 137 -180 321 -131 546 27
125 148 286 269 357 81 48 191 84 304 101 l90 13 -67 27 c-123 49 -274 66
-413 46z"/>
<path d="M7042 2636 c-23 -8 -59 -26 -78 -41 -39 -30 -84 -114 -84 -157 l0
-28 -1980 0 c-1313 0 -1980 -3 -1980 -10 0 -7 667 -10 1980 -10 l1979 0 12
-40 c16 -53 73 -118 123 -141 53 -24 139 -24 191 0 22 10 57 36 77 59 102 113
65 287 -78 360 -36 19 -116 23 -162 8z"/>
</g>
</svg>








    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
